import anime from 'animejs/lib/anime.es.js';
( function() {
    console.log('hello anime');

    const targets = document.querySelectorAll('.animate-on-scroll');

    const callback = function ( entries ) {
        entries.forEach(entry => {

            if (entry.isIntersecting) {
                console.log('aa');
                  

                if(entry.target.classList.contains('right-anim')) {
                    anime({
                        targets: entry.target,
                        duration: 550,
                        translateX: [100, 0],
                        opacity: [0, 1],
                        easing: 'easeInOutQuad'
                    });
                } else {
                    anime({
                        targets: entry.target,
                        duration: 550,
                        translateX: [-100, 0],
                        opacity: [0, 1],
                        easing: 'easeInOutQuad'
                    }); 
                }

               

                observer.unobserve(entry.target)
         
            } else {

            } 
        })
    }

    let observer = new IntersectionObserver(callback, {
        rootMargin: "10px",
    });

    targets.forEach(function(target) {
        target.classList.add("opacity-0");
        observer.observe(target);
    })
}() );

